import { useState } from 'react';
import { Toggles } from 'src/services/toggles/types';

export default function useTogglesService(toggles: Toggles) {
  const [togglesState] = useState(toggles);

  return togglesState;
}
